export default __webpack_public_path__ + "static/media/cup.b2186a6f.webp";